module.exports = __webpack_public_path__ + "img/tddg-6.c0eb5444.jpg";